export enum ItemType {
  Export = "Export",
  Reimport = "Reimport",
  Makro = "Makro",
  CategoryExport = "CategoryExport",
}
